export const ROLES = ["owner", "administrator", "responder", "viewer"];
export const INCIDENT_STATUSES = [
    "reported",
    "acknowledged",
    "investigating",
    "monitoring",
    "resolved"
];
export const INCIDENT_PRIORITIES = ["P1", "P2", "P3", "P4"];
export const INCIDENT_SEVERITIES = ["SEV1", "SEV2", "SEV3", "SEV4"];
export const TIMELINE_KINDS = [
    "incident_created",
    "status_changed",
    "assignment_changed",
    "classification_changed",
    "sla_changed",
    "comment"
];
